<app-dialog-top>
    <div class="d-flex align-items-center">
        <div class="">
            <p class="m-0 p-0 fs-6 lh-1">
                {{'PAGE_TITLE.CONTACT_US' | translate}}
            </p>
        </div>
    </div>
</app-dialog-top>

<div mat-dialog-content>
    <app-form-contact-us [(submited)]="submited" (onClose)="close($event)" class="h-100"></app-form-contact-us>
</div>

<app-dialog-bottom (onSaveClick)="onSubmit($event)" saveIcon="fa-solid fa-paper-plane" [saveText]="'COMMON.ACTION_SUBMIT' | translate"></app-dialog-bottom>
